import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';

export const go = action('[Navigation] go', props<{ timestamp: number }>());

export const setTimestamp = action(
  '[Navigation] setTimestamp',
  props<{ timestamp: number } & SkipHistory>(),
);

export const start = action(
  '[Navigation] start',
  props<{ offset: number } & SkipHistory>(),
);

export const stop = action('[Navigation] stop', props<SkipHistory>());
